import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const PortalDropdown = ({ anchorRef, open, children, onClose }) => {
    const [coords, setCoords] = useState({ top: 0, left: 0, width: 0 });

    useEffect(() => {
        if (!open || !anchorRef.current) return;
        const updateCoords = () => {
            const rect = anchorRef.current.getBoundingClientRect();
            const estimatedDropdownWidth = Math.max(rect.width, 160);
            const wouldOverflow = rect.left + estimatedDropdownWidth > window.innerWidth;
            setCoords({
                top: rect.bottom + window.scrollY + 4,
                left: wouldOverflow
                    ? rect.right + window.scrollX - estimatedDropdownWidth
                    : rect.left + window.scrollX,
                width: rect.width,
            });
        };
        updateCoords();
        window.addEventListener('scroll', updateCoords, true);
        window.addEventListener('resize', updateCoords);
        return () => {
            window.removeEventListener('scroll', updateCoords, true);
            window.removeEventListener('resize', updateCoords);
        };
    }, [open, anchorRef]);

    useEffect(() => {
        if (!open) return;
        const handler = (e) => {
            if (anchorRef.current && anchorRef.current.contains(e.target)) return;
            onClose();
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [open, onClose, anchorRef]);

    if (!open) return null;

    return createPortal(
        <div style={{ position: 'absolute', top: coords.top, left: coords.left, width: coords.width, minWidth: 160, zIndex: 9999 }}>
            {children}
        </div>,
        document.body
    );
};

export default PortalDropdown;
